import { createRouter, createWebHistory } from "vue-router";
import HeaderComponent from '/src/components/HeaderComponent.vue'
import App from '/src/App.vue'
import AboutComponent from '/src/components/AboutComponent.vue'
import QualificationComponent from '/src/components/QualificationComponent.vue'
import ContactComponent from '/src/components/ContactComponent.vue'


const routes = [
    {
      path: '/',

      component: App
    },
    {
      path: '/HeaderComponent',
      
      component: HeaderComponent
    },
    {
      path: '/AboutComponent',
      
      component: AboutComponent
    },
    {
      path: '/QualificationComponent',
      
      component: QualificationComponent
    },
    {
      path: '/ContactComponent',
     
      component: ContactComponent
    }
  
  ]
  
  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })
  
  export default router
  